import api from '../api';

export const getListSectionPage = async (id) => {
    const result = await api.get(`/admin/sectionpage/${id}`);
    return result.data;
}

export const getOneSectionPage = async (id) => {
    const result = await api.get(`/admin/sectionpage/${id}`);
    return result.data.data;
}

export const addSectionToPage = async (data, id) => {
    try {
        const response = await api.post(`/admin/sectionpage/${id}`, data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const deleteSectionPage = async (id) => {
    try {
        const response = await api.delete(`/admin/sectionpage/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateStatusSectionPage = async (id) => {
    try {
        const response = await api.put(`/admin/status/sectionpage/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateOrderSectionPage = async (data, id) => {
    try {
        const response = await api.put(`/admin/order/sectionpage/${id}`, { data });
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}


